import { useEffect } from 'react';
import PropTypes from 'prop-types';

import initAnalytics from 'public/assets/js/analytics';

const propTypes = {
  route: PropTypes.string.isRequired,
};

const TutorialScripts = () => {
  useEffect(() => {
    initAnalytics();

    return () => {
      window.removeEventListener('hashchange');
    };
  }, []);

  return null;
};
TutorialScripts.propTypes = propTypes;

export default TutorialScripts;
